import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import muiThemeable from 'material-ui/styles/muiThemeable';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import {Title, Body1} from './Typography';
import GetInTouchSection from './GetInTouchSection';

import firebase from './firebase';

const styles = {
  radioButton: {
    marginBottom: 16,
  },
};

export default muiThemeable()(class SignupPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tosErrorHidden: true,
      tosAndPrivacyChecked: false,
      signupDialogOpen: false,
      snackbarOpen: false,
      snackbarMessage: '',
    };
  }

  onSubmit() {
    console.log(this.state);
    var data = {};
    var validationFailed = false;
    var expectedFields = ['fname', 'lname', 'email', 'phone', 'ship-address',
        'ship-city', 'ship-state', 'ship-zip', 'rent-or-own', 'household-size', 'maximum-subscription-price', 'maximum-purchase-price'];

    for (var i = 0; i < expectedFields.length; i++) {
      var field = expectedFields[i];

      var newState = {};
      if (field in this.state && this.state[field] !== "") {
        newState[field + 'ErrorText'] = "";
        this.setState(newState);
        data[field] = this.state[field];
      } else {
        validationFailed = true;
        newState[field + 'ErrorText'] = "This field is required";
        this.setState(newState);
      }
    }

    data['timestamp-submitted'] = firebase.database.ServerValue.TIMESTAMP;

    if (validationFailed) {
      console.log("validation failed");
      data['partial'] = true;
      firebase.database().ref('customer-submissions').push(data);
      this.setState({snackbarMessage: "Every field is required, please complete and try submitting again.", snackbarOpen: true})
      return;
    }

    firebase.database().ref('customer-submissions').push(data).then(
      // success
      () => window.location = "/signup-success",
      // failure
      (error) => this.setState({snackbarMessage: "Sorry, something went wrong. Try again?", snackbarOpen: true})
    );
  }

  handleChange = (event) => {
    var newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  }

  onCheck = (event, isInputChecked) => {
    this.setState({tosAndPrivacyChecked: isInputChecked});
  }

  render() {
    return (
      <div>
        <HomeGalleryHeader />
        <div className="SignupPage"
          style={{
            backgroundColor: this.props.muiTheme.palette.canvasColor,
            paddingTop: "2em",
          }}>
          <div
            style={{
              width: '500px',
              maxWidth: '90%',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: "left",
            }}>

            <form id="artistSignupForm">
              <Title marginTop="1em">Join Home Gallery Project</Title>
              <Body1>
              We're currently accepting applications to expand our private beta. If you're interested, please fill out the following information to join our waiting list.
              </Body1>

              <Title marginTop="1em">Name & Contact Information</Title>
              <div>
                <TextField errorText={this.state['fnameErrorText']} onChange={this.handleChange} className="formField" name="fname" floatingLabelText="First Name" />
              </div>
              <div>
                <TextField errorText={this.state['lnameErrorText']} onChange={this.handleChange} className="formField" name="lname" floatingLabelText="Last Name" />
              </div>
              <div>
                <TextField errorText={this.state['emailErrorText']} onChange={this.handleChange} className="formField" name="email" floatingLabelText="Email Address" type="email"></TextField>
              </div>
              <div>
                <TextField errorText={this.state['phoneErrorText']} onChange={this.handleChange} className="formField" type="tel" name="phone" floatingLabelText="Phone Number"></TextField>
              </div>

              <Title marginTop="1em">Delivery Address</Title>
              <div><TextField errorText={this.state['ship-addressErrorText']} onChange={this.handleChange} className="formField" name="ship-address" floatingLabelText="Address" /></div>
              <div><TextField errorText={this.state['ship-cityErrorText']} onChange={this.handleChange} className="formField" name="ship-city" floatingLabelText="City" /></div>
              <div><TextField errorText={this.state['ship-stateErrorText']} onChange={this.handleChange} className="formField" name="ship-state" floatingLabelText="State" /></div>
              <div><TextField errorText={this.state['ship-zipErrorText']} onChange={this.handleChange} className="formField" name="ship-zip" floatingLabelText="Zipcode" /></div>

              <Title marginTop="1em">Do you rent or own?</Title>
                <RadioButtonGroup onChange={this.handleChange} style={{marginTop: "1em"}} name="rent-or-own">
                  <RadioButton
                    value="rent"
                    label="I rent my home"
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="own"
                    label="I own my home"
                    style={styles.radioButton}
                  />
                </RadioButtonGroup>
                <p hidden={!this.state['rent-or-ownErrorText']} style={{color: "#f44336"}}>{this.state['rent-or-ownErrorText']}</p>


                <Title marginTop="1em">How many people live in your home?</Title>
                <div><TextField errorText={this.state['household-sizeErrorText']} onChange={this.handleChange} className="formField" name="household-size" type="number" hintText="Number of people" /></div>

                <Title marginTop="1em">The monthly delivery cost varies based on the size and quality of the artwork. What is your budget for monthly deliveries of art?</Title>
                <div><TextField errorText={this.state['maximum-subscription-priceErrorText']} onChange={this.handleChange} className="formField" name="maximum-subscription-price" hintText="Price per month" /></div>

                <Title marginTop="1em">If you get a piece of art you love, how much would you purchase it for?</Title>
                <div><TextField errorText={this.state['maximum-purchase-priceErrorText']} onChange={this.handleChange} className="formField" name="maximum-purchase-price" hintText="Purchase price" /></div>
            </form>
            <RaisedButton primary={true}
              style={{marginTop: '1em', color: this.props.muiTheme.palette.alternateTextColor}}
              onClick={this.onSubmit.bind(this)}>
              Submit
            </RaisedButton>
          </div>

          <GetInTouchSection />

          <Snackbar
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            autoHideDuration={10000}
            onRequestClose={() => this.setState({snackbarOpen: false})}
          />

        </div>
        <HomeGalleryFooter />
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/SignupPage.js